import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    header: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        paddingTop: 5,
        paddingBottom: 8,
        alignItems: 'center',
        marginBottom: 8
    },
    col1: {
        width: '30%',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 8,
    },
    col2: {
        width: '70%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
    },
    headerText: {
        fontSize: 12,
        fontWeight: 700
    },
    switch: {
        "& .Mui-checked": {
            color: '#fff'
        },
        '&  .Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#69ABCF',
            color: '#69ABCF',
            opacity: 1
        },
    },
    mainContent: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 10,
        paddingBottom: 25,
        paddingLeft: 20,
        paddingRight: 20
    }
});